/* broat – Vorbestellung (ergänzt theme.js)
   Produktseite, Set-Baukasten und alle übrigen Kaufen-Formulare:
   Vorbestellbare Varianten lassen sich erst nach Bestätigung per Checkbox in den Warenkorb legen. */
(() => {
  'use strict';
  const PO = (window.theme || {}).preorder;
  if (!PO) return;
  const ICON = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>';
  const preIds = new Set((PO.variants || []).map(Number));
  const LABEL = PO.label || 'Vorbestellung';
  let uid = 0;

  function noteEl() {
    const n = document.createElement('div');
    n.className = 'preorder-note';
    n.setAttribute('role', 'status');
    n.innerHTML = ICON + '<div>' + (PO.note || '') + '</div>';
    return n;
  }
  function confirmEl() {
    const id = 'PreorderConfirm-' + (++uid);
    const w = document.createElement('label');
    w.className = 'preorder-confirm';
    w.setAttribute('for', id);
    w.innerHTML = '<input type="checkbox" id="' + id + '" data-preorder-confirm><span>' + (PO.confirm || '') + '</span>';
    return w;
  }
  function flash(box) {
    if (!box) return;
    box.classList.remove('is-required'); void box.offsetWidth; box.classList.add('is-required');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const msg = PO.confirmNeeded;
    const t = document.querySelector('[data-toast]');
    if (t && msg) { t.textContent = msg; t.hidden = false; setTimeout(() => { t.hidden = true; }, 3200); }
  }
  function xlEl() {
    if (!PO.xl || !PO.xl.length) return null;
    const box = document.createElement('div');
    box.className = 'preorder-xl';
    let html = '<p class="preorder-xl__intro">' + (PO.xlIntro || '') + '</p><ul class="preorder-xl__list" role="list">';
    PO.xl.forEach((x) => {
      html += '<li><a class="preorder-xl__item" href="' + x.url + '">' +
        (x.img ? '<img src="' + x.img + '" alt="" width="56" height="56" loading="lazy">' : '') +
        '<span class="preorder-xl__txt"><strong>' + x.title + '</strong><span>ab ' + x.price + '</span></span>' +
        '<span class="btn btn--sm btn--secondary">' + (PO.xlButton || 'Zur XL-Packung') + '</span></a></li>';
    });
    box.innerHTML = html + '</ul>';
    return box;
  }

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    const dataEl = root.querySelector('[data-product-json]');
    const form = root.querySelector('form[data-add-form]');
    if (!dataEl || !form || form.dataset.preorderReady) return;
    const product = JSON.parse(dataEl.textContent);
    if (!product.variants.some((v) => preIds.has(Number(v.id)))) return;
    form.dataset.preorderReady = '1';
    form.dataset.preorderMain = '1';
    const idInput = form.querySelector('input[name=id]');

    const wrap = document.createElement('div');
    wrap.className = 'preorder-box';
    const note = noteEl();
    const conf = confirmEl();
    note.querySelector('div').appendChild(conf);
    wrap.appendChild(note);
    const xl = xlEl();
    if (xl) wrap.appendChild(xl);
    const buy = form.querySelector('.buy');
    form.insertBefore(wrap, buy || form.firstChild);
    const cb = conf.querySelector('input');

    const prop = document.createElement('input');
    prop.type = 'hidden';
    prop.name = 'properties[' + LABEL + ']';
    prop.value = PO.value || '';
    form.appendChild(prop);

    const btns = Array.from(root.querySelectorAll('[data-atc]')).concat(Array.from(document.querySelectorAll('[data-atc-sticky]')));
    let isPre = false;
    function apply() {
      const id = parseInt(idInput && idInput.value, 10);
      const v = product.variants.find((x) => x.id === id);
      isPre = !!v && v.available && preIds.has(id);
      wrap.hidden = !isPre;
      prop.disabled = !isPre;
      form.dataset.preorderOk = (!isPre || cb.checked) ? '1' : '';
      btns.forEach((b) => {
        const l = b.querySelector('[data-atc-label]') || b;
        if (isPre) {
          l.textContent = PO.button || 'Vorbestellen';
          b.classList.toggle('is-preorder-locked', !cb.checked);
          b.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
        } else {
          b.classList.remove('is-preorder-locked');
          b.removeAttribute('aria-disabled');
        }
      });
    }
    form._preorderFlash = () => flash(conf);
    cb.addEventListener('change', apply);
    const picker = root.querySelector('[data-variant-picker]');
    picker && picker.addEventListener('change', () => setTimeout(apply, 0));
    apply();
  }

  /* ---------- Set-Baukasten ---------- */
  function initBundle(sec) {
    if (sec.dataset.preorderReady) return;
    sec.dataset.preorderReady = '1';
    let found = false;
    sec.querySelectorAll('[data-bb-variants]').forEach((el) => {
      try { JSON.parse(el.textContent).forEach((v) => { if (v.preorder) { preIds.add(Number(v.id)); found = true; } }); } catch (e) { /* ignorieren */ }
    });
    if (!found) return;
    const grid = sec.querySelector('.bb__grid');
    if (grid) {
      const n = noteEl();
      const link = document.createElement('p');
      link.className = 'preorder-xl__intro';
      link.style.marginTop = '.5rem';
      link.innerHTML = (PO.xlIntro || '') + ' <a href="' + (PO.xlCollection || '/collections/backmischungen-xl') + '">' + (PO.xlButton || 'Zur XL-Packung') + '</a>';
      n.querySelector('div').appendChild(link);
      grid.parentNode.insertBefore(n, grid);
    }
    const submit = sec.querySelector('[data-bb-submit]');
    if (submit) {
      const conf = confirmEl();
      conf.classList.add('preorder-confirm--box');
      submit.parentNode.insertBefore(conf, submit);
      sec._preorderConf = conf;
    }
  }
  // Klick auf „Set in den Warenkorb“ abfangen, solange nicht bestätigt
  document.addEventListener('click', (e) => {
    const submit = e.target.closest('[data-bb-submit]');
    if (!submit) return;
    const sec = submit.closest('[data-bundle]');
    const conf = sec && sec._preorderConf;
    if (!conf) return;
    if (!conf.querySelector('input').checked) {
      e.preventDefault(); e.stopImmediatePropagation();
      flash(conf);
    }
  }, true);

  /* ---------- Alle Kaufen-Formulare (Produktseite, Empfehlungen, Karten) ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form) return;
    const idEl = form.querySelector('[name=id]');
    const id = Number(idEl && idEl.value);
    if (!preIds.has(id)) return;
    if (form.dataset.preorderMain) {
      if (form.dataset.preorderOk === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      form._preorderFlash && form._preorderFlash();
      return;
    }
    // Schnellkauf ohne Bestätigung: zur Produktseite, dort bestätigen
    e.preventDefault(); e.stopImmediatePropagation();
    const scope = form.closest('.upsell__item, .card, li, article') || form.parentNode;
    const a = scope && scope.querySelector('a[href*="/products/"]');
    if (a) window.location.href = a.href;
  }, true);

  /* ---------- Warenkorb-API: Vermerk an Set-Positionen ---------- */
  function patchCart() {
    const C = window.BroatCart;
    if (!C || C._preorderPatched || !C.addItems) return;
    const orig = C.addItems.bind(C);
    C.addItems = (items, button, replaceKey) => {
      (items || []).forEach((it) => {
        if (preIds.has(Number(it.id))) { it.properties = it.properties || {}; it.properties[LABEL] = PO.value || ''; }
      });
      return orig(items, button, replaceKey);
    };
    C._preorderPatched = true;
  }

  function run(scope) {
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    scope.querySelectorAll('[data-bundle]').forEach(initBundle);
    patchCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
